<!--
 * @Description: lbRefundOrder
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2023-12-11 14:50:47
 * @LastEditTime: 2024-01-22 09:54:29
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
-->

<template>
  <el-dialog
    :title="$t('action.agreeRefund')"
    :visible.sync="showDialog"
    width="900px"
    center
  >
    <div
      class="flex-warp pb-lg"
      v-for="(aitem, aindex) in refundForm.order_goods"
      :key="aindex"
    >
      <lb-image class="avatar radius-5" :src="aitem.goods_cover" />
      <div class="flex-1 ml-md">
        <div class="flex-between">
          <div class="c-title">{{ aitem.goods_name }}</div>
          <div
            :style="{
              color:
                refundForm.pay_type == 2
                  ? primaryColor
                  : [3, 4, 5].includes(refundForm.pay_type)
                  ? subColor
                  : refundForm.pay_type == 6
                  ? '#11C95E'
                  : '#333'
            }"
          >
            {{ statusType[refundForm.pay_type] }}
          </div>
        </div>
        <div style="margin-top: 3px; height: 16px">
          <div
            class="flex-y-baseline f-caption c-title"
            v-if="aitem.material_price * 1 > 0"
          >
            物料费：
            <div class="c-warning">¥{{ aitem.material_price || 0 }}</div>
          </div>
        </div>
        <div class="flex-between" style="margin-top: 3px">
          <div class="flex-y-baseline">
            <div class="c-warning mr-md">¥{{ aitem.goods_price || 0 }}</div>
          </div>
          <div class="c-caption">x{{ aitem.num }}</div>
        </div>
        <div class="flex-y-center mt-md">
          <div class="mr-lg" v-if="aitem.goods_price * 1 > 0">
            项目金额：
            <el-input-number
              @change="handleCheckOrderItem(aindex)"
              v-model="aitem.refund_price"
              class="lb-input-number"
              :controls="false"
              :min="0.01"
              :max="aitem.goods_price"
              :precision="2"
              size="mini"
              style="width: 80px"
            ></el-input-number>
          </div>
          <div class="mr-lg" v-if="aitem.material_price * 1 > 0">
            物料费：
            <el-input-number
              @change="handleCheckOrderItem(aindex)"
              v-model="aitem.refund_material_price"
              class="lb-input-number"
              :controls="false"
              :min="0.0"
              :max="aitem.material_price"
              :precision="2"
              size="mini"
              style="width: 80px"
            ></el-input-number>
          </div>
          <div class="mr-lg">退款数量：{{ aitem.num }}</div>
          <div class="flex-y-center">
            累计退款金额：
            <div class="c-warning text-bold">
              ¥{{ aitem.total_refund_price }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex-y-center pt-lg pb-lg"
      style="margin-left: 30px; border-top: 1px dashed rgba(0, 0, 0, 0.1)"
    >
      <div class="flex-y-center mr-lg" v-if="refundForm.car_price * 1 > 0">
        车费：
        <el-input-number
          @change="handleCheckOrderItem(-1)"
          v-model="refundForm.refund_car_price"
          class="lb-input-number"
          :controls="false"
          :min="0"
          :max="refundForm.car_price"
          :precision="2"
          size="mini"
          style="width: 120px"
        ></el-input-number>
      </div>
      <div class="flex-y-center">
        总计退款金额：
        <div class="c-warning text-bold">
          ¥{{ refundForm.total_refund_price }}
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showDialog = false">取 消</el-button>
      <el-button type="primary" @click="toConfirmRefund" v-preventReClick
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'lbRefundOrder',
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      primaryColor: '',
      subColor: '',
      statusType: {
        '-1': '已取消',
        1: '待支付',
        2: '待接单',
        3: '已接单',
        4: '已出发',
        5: '已到达',
        6: '服务中',
        7: '已完成',
        8: '待转单'
      },
      showDialog: false,
      refundForm: {}
    }
  },
  computed: {
    ...mapState({
      routesItem: state => state.routes
    })
  },
  methods: {
    async toPassRefund (id) {
      let [config, order] = await Promise.all([this.$api.system.configInfo(), this.$api.shop.refundOrderInfo({ id })])
      let { primaryColor, subColor } = config.data
      this.primaryColor = primaryColor
      this.subColor = subColor
      let data = this.$util.pick(order.data, ['id', 'car_price', 'material_price', 'order_goods', 'pay_type'])
      data.refund_car_price = data.car_price
      let total = 0
      data.order_goods.map(aitem => {
        let { num, goods_price: price, material_price: mprice } = aitem
        aitem.refund_price = price
        aitem.refund_material_price = mprice
        aitem.total_refund_price = (price * num + mprice * num).toFixed(2)
        total += aitem.total_refund_price * 1
      })
      data.total_refund_price = total + data.car_price
      this.refundForm = data
      this.showDialog = !this.showDialog
    },
    handleCheckOrderItem (index = 0) {
      let { refund_car_price: cprice, order_goods: goods } = this.refundForm
      let reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
      if (index > -1) {
        let { num, refund_price: rtprice, refund_material_price: rmprice } = goods[index]
        if (!reg.test(rtprice)) {
          rtprice = 0.01
        }
        if (!reg.test(rmprice)) {
          rmprice = 0
        }
        let trprice = (rtprice * num + rmprice * num).toFixed(2)
        this.$nextTick(() => {
          this.refundForm.order_goods[index].refund_price = rtprice
          this.refundForm.order_goods[index].refund_material_price = rmprice
          this.refundForm.order_goods[index].total_refund_price = trprice
        }, 0)
      }

      if (!reg.test(cprice)) {
        cprice = 0
      }
      this.$nextTick(() => {
        this.refundForm.refund_car_price = cprice
      }, 0)

      setTimeout(() => {
        let total = 0
        this.refundForm.order_goods.map(item => {
          total += item.total_refund_price * 1
        })
        total += cprice * 1
        this.refundForm.total_refund_price = total.toFixed(2)
      }, 100)
    },
    /**
     * @name: 确认退款
     */
    async toConfirmRefund () {
      let subForm = JSON.parse(JSON.stringify(this.refundForm))
      let { id: oid, refund_car_price: cprice, total_refund_price: trprice, order_goods: list } = subForm
      let param = {
        order_id: oid,
        car_price: cprice,
        price: trprice,
        list: [],
        text: ''
      }
      list.map(item => {
        let { id, refund_price: rprice, refund_material_price: mprice } = item
        param.list.push({
          id,
          goods_price: rprice,
          material_price: mprice
        })
      })
      let { code } = await this.$api.shop.passRefundV2(param)
      if (code !== 200) return
      this.$message.success(this.$t('tips.successOper'))
      this.showDialog = false
      this.$emit('change')
    },
    /**
     * @method: 拒绝退款
     */
    toRefuseRefund (id) {
      this.$confirm(this.$t('tips.confirmNoRefund'), this.$t('tips.reminder'), {
        confirmButtonText: this.$t('action.comfirm'),
        cancelButtonText: this.$t('action.cancel'),
        type: 'warning'
      }).then(() => {
        this.$api.shop.noPassRefund({ id, text: '' }).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('tips.successOper'))
            this.$emit('change')
          }
        })
      }).catch(() => { })
    }
  },
  filters: {
    handleTime (val, type) {
      let time = type === 1 ? moment(val * 1000).format('YYYY-MM-DD') : type === 2 ? moment(val * 1000).format('HH:mm:ss') : moment(val * 1000).format('YYYY-MM-DD HH:mm:ss')
      return time
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/basics/lbRefundOrder.vue